__turbopack_context__.v({
  "bannerText": "styles-module__210Aaq__bannerText",
  "bannerWrapper": "styles-module__210Aaq__bannerWrapper",
});
